import _ from 'lodash';
import $ from 'jquery';
import Immutable from 'immutable';
import React from 'react';
import cx from '../../utils/cx.js';
import GalleryActionCreators from '../../actions/GalleryActionCreators.js';
import ImageSvg from '../images/ImageSvg.react';
import GalleryStore from '../../stores/GalleryStore';
import MemberStore from '../../stores/MemberStore';
import GalleryThumb from './GalleryThumb.react';

const gallery = $('#gallery');
const slideStep = 4; // slide lapošana - par cik pozīcijām pabīdīt

// lai varētu aprēķināt lielumus priekš navigācijas
const initParams = {
  maxWidth: 1024, // max platums
  sidePadding: 10, // padding pa malām (kreisā, labā puse)
  sideButtonPadding: 24, // padding, ja ir navigācijas pogas
  thumbSize: 81, // thumb izmērs (kvadrāts)
  thumbMarginRight: 10, //  thumbs margin pa labi
};

// mainīgie parametri, atjaunojas pie resize, bilžu pārslēgšanās
const params = {
  innerWidth: 0, // platums galleryBoxThumbs-slide-inner
  innerLeft: 0, // pa cik nepieciešams nobītīt elementus
  slideWidth: 0, // platums galleryBoxThumbs-slide
  slideItems: 0, // cik elementi (thumbs) ietilpst vienā slide skatā
  thumbSize: 0, // thumb izmērs ar visiem padding, margin
};

// state vērtības no store
function getStateFromStores() {
  return {
    index: GalleryStore.getCurrentIndex(), // bildes indekss vērtība
    total: GalleryStore.getTotal(),
    images: GalleryStore.getImages(),
    member: MemberStore.get(_.get(globals, 'memberId', '')),
  };
}

// aprēkiņa slider izmēru, thumb pozīcijas, uc
function calculateParams(total, index) {
  if (typeof index === 'undefined') {
    return {
      slideFirstImageIndex: 0,
      hasButtons: false,
    };
  }

  // thumb izmērs + margin/padding
  params.thumbSize = initParams.thumbSize + initParams.thumbMarginRight;

  // aprēķina galleryBoxThumbs-slide-inner platumu
  params.innerWidth = params.thumbSize * total - initParams.thumbMarginRight;

  // aprēķia, cik plats ir galleryBoxThumbs-slide
  const galleryWidth = gallery.width();

  // ja samazināts ekrāns
  if (galleryWidth < initParams.maxWidth) {
    params.slideWidth = galleryWidth;
  }
  // normālā gadījumā ņem maxWidth
  else {
    params.slideWidth = initParams.maxWidth;
  }

  // atņem padding vērtību
  // slideWidth bez pogām
  const slideWidthNoButtons = params.slideWidth - initParams.sidePadding * 2;

  // pārbauda, vai nepieciešams rādīt pogas (prev, next)
  // nevajag pogas
  let hasButtons = false;
  if (slideWidthNoButtons >= params.innerWidth) {
    params.slideWidth = slideWidthNoButtons;
  }
  // vajag pogas
  else {
    params.slideWidth -= initParams.sideButtonPadding * 2;
    hasButtons = true;
  }

  // aprēķina, cik thumbs ietilpst vienā slide skatā
  params.slideItems = Math.floor(params.slideWidth / params.thumbSize);

  let slideFirstImageIndex = 0;

  // ja ir pogas, tad slideFirstImageIndex var mainīties
  if (hasButtons) {
    // vidējā pozīcijas
    const slideItemsMid = Math.ceil(params.slideItems / 2);

    // novirza tā, lai aktīvā bilde būtu pa vidu
    // + 1 , jo slideFirstImageIndex sākas no 0
    slideFirstImageIndex = index - slideItemsMid + 1;

    // neļaut virzīties ārpus rāmjiem (pa kreisi)
    if (slideFirstImageIndex < 0) {
      slideFirstImageIndex = 0;
    }
    // (pa labi)
    else if (slideFirstImageIndex + params.slideItems > total) {
      slideFirstImageIndex = total - params.slideItems;
    }
  }

  return {
    slideFirstImageIndex,
    hasButtons,
  };
}

class GalleryBoxThumbs extends React.PureComponent {
	static displayName = 'GalleryBoxThumbs';

	constructor(props) {
	  super(props);
	  const data = getStateFromStores();
	  const calculatedData = calculateParams(data.total, data.index);

	  // slide pirmās bildes indekss (bilde, kura iekš slide rādās pirmajā pozīcijā)
	  // sākas no 0
	  data.slideFirstImageIndex = calculatedData.slideFirstImageIndex;
	  // vai rādīt thumb pārslēgšanās pogas
	  data.hasButtons = calculatedData.hasButtons;

	  this.state = {
	    data: Immutable.Map(data),
	  };
	}

	setImmState = fn => this.setState((prevState) => {
	  const data = prevState.data;
	  return {
	    data: fn(data),
	  };
	});

	// thumb pogas - pa labi vai kreisi pārvietot thumb bildes
	// action - 'prev' vai 'next'
	buttonClick = (action) => {
	  const data = this.state.data;
	  const total = data.get('total');
	  let slideFirstImageIndex = data.get('slideFirstImageIndex');
	  let step = slideStep;

	  // ja step ir lielāks par skaitu, kāds tiek attēlots vienā slaidā, tad samazina step
	  if (step > params.slideItems) {
	    step = params.slideItems;
	  }

	  if (action == 'next') {
	    slideFirstImageIndex += step;
	  } else {
	    slideFirstImageIndex -= step;
	  }

	  // pārbauda vai nepārsniedz robežas
	  if (slideFirstImageIndex < 0) {
	    slideFirstImageIndex = 0;
	  } else if (slideFirstImageIndex + params.slideItems > total) {
	    slideFirstImageIndex = total - params.slideItems;
	  }

	  // pārbauda, vai ir jauna vērtība, ja nav, tad neuzseto jauno vērtību
	  if (slideFirstImageIndex == data.get('slideFirstImageIndex')) {
	    return false;
	  }

	  // jauna state vērtība
	  this.setImmState(data => data.update('slideFirstImageIndex', item => slideFirstImageIndex));
	};

	componentDidMount() {
	  window.addEventListener('resize', this._onResize);
	  GalleryStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
	  window.removeEventListener('resize', this._onResize);
	  GalleryStore.removeChangeListener(this._onChange);
	}

	render() {
	  const data = this.state.data;
	  const total = data.get('total');
	  const hasButtons = data.get('hasButtons');
	  if (!total) {
	    return null;
	  }

	  const self = this;
	  const ImagesItems = [];

	  // thumb css vērtības
	  const thumbStyle = {
	    width: initParams.thumbSize,
	    height: this.props.thumbnailSize === 'm' ? (initParams.thumbSize)  * 4 / 3 : initParams.thumbSize, // haha
	    marginRight: initParams.thumbMarginRight,
	    float: 'left',
	  };

	  // nepieciešams norādīt dzimumu katrai bildei
	  let sex = null;
	  if (!_.isEmpty(data.get('member')) && !_.isEmpty(data.get('member').sex)) {
	    sex = data.get('member').sex.toLowerCase();
	  }

	  data.get('images').forEach((image) => {
	    const onClick = self._onClick.bind(self, image.index);
	    let style = thumbStyle;
	    // pēdējam noņem margin-right
	    if ((total - 1) == image.get('index')) {
	      // izveido dublikātu, lai nomainītu css vērtību konkrētam elementam
	      style = _.cloneDeep(thumbStyle);
	      style.marginRight = 0;
	    }
	    ImagesItems.push(
	      <div style={style} key={image.file}>
	        <GalleryThumb
	          filename={image.file}
	          sex={sex}
	          onClick={onClick}
	          active={(data.get('index') == image.index)}
	          gcloud={image.gcloud}
	          uncensored={image.uncensored}
			  size={this.props.thumbnailSize}
	        />
	      </div>
	    );
	  });

	  const slideStyle = {
	    height: this.props.thumbnailSize === 'm' ? (initParams.thumbSize) * 4 / 3: initParams.thumbSize,
	  };

	  const innerStyle = {
	    width: params.innerWidth,
	    left: data.get('slideFirstImageIndex') * params.thumbSize * -1,
	  };

	  const ButtonLeft = function () {
	    if (!hasButtons) {
	      return null;
	    }

	    return (
  <a href="#" onClick={function () { self.buttonClick('prev'); }} className="galleryBoxThumbs-button">
    <ImageSvg svg="icon-arrowLeftLarge" />
  </a>
	    );
	  };

	  const ButtonRight = function () {
	    if (!hasButtons) {
	      return null;
	    }

	    return (
  <a href="#" onClick={function () { self.buttonClick('next'); }} className="galleryBoxThumbs-button galleryBoxThumbs-button--right">
    <ImageSvg svg="icon-arrowRightLarge" />
  </a>
	    );
	  };

	  return (
  <div
    className={cx([
					'galleryBoxThumbs',
					['has-buttons', hasButtons],
					['galleryBoxThumbs--inline', this.props.displayInline],
				])}

    onClick={self._onClickStop}
  >
    {ButtonRight()}
    {ButtonLeft()}
    <div className="galleryBoxThumbs-slide" style={slideStyle}>
      <div className="galleryBoxThumbs-slide-inner" style={innerStyle}>
        {ImagesItems}
      </div>
    </div>
  </div>
	  );
	}

	/**
	* Event handler for 'change' events coming from the stores
	*/
	_onChange = () => {
	  const stateData = getStateFromStores();
	  const calculatedData = calculateParams(stateData.total, stateData.index);

	  // slide pirmās bildes indekss (bilde, kura iekš slide rādās pirmajā pozīcijā)
	  // sākas no 0
	  stateData.slideFirstImageIndex = calculatedData.slideFirstImageIndex;
	  // vai rādīt thumb pārslēgšanās pogas
	  stateData.hasButtons = calculatedData.hasButtons;

	  // pārveido par immutable MAP, lai būtu korekts merge
	  const stateDataImm = Immutable.Map(stateData);

	  this.setImmState(data => data.merge(stateDataImm));
	};

	/**
	* Event handler for 'onClick' - klikšķis uz thumb bildes
	*/
	_onClick = (index) => {
		// call parent onClickAction if it is defined
		if (this.props.onClickAction) {
			this.props.onClickAction(index);
		}
	  	GalleryActionCreators.goToImage(index);
	};

	/**
	* Event handler for 'resize'
	*/
	_onResize = () => {
	  const data = this.state.data;
	  const calculatedData = calculateParams(data.get('total'), data.get('index'));

	  // pārveido par immutable MAP, lai būtu korekts merge
	  const stateDataImm = Immutable.Map(calculatedData);

	  this.setImmState(data => data.merge(stateDataImm));
	};

	_onClickStop = (e) => {
	  e.stopPropagation();
	};

	/* shouldComponentUpdate(nextProps, nextState) {
		 return React.addons.shallowCompare(this, nextProps, nextState);
		 } */
}

module.exports = GalleryBoxThumbs;
